import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import PaymentContact from "app/pages/Booking/Payment/PaymentContact";
import { bindActionCreators } from "redux";
import { shouldGetProfileAtPayment } from "src/@brand/appConstants";
import { getProfile } from "app/pages/Account/Profile/profileActionCreators";
import { PROFILE_CODE_STATUS } from "app/constants";
import { withRouter } from "react-router-dom";
import { getCurrentShop } from "app/reducers/shopSelector";
import { isAuthenticated } from "app/pages/Auth/authSelectors";

class PaymentContactContainer extends Component {
	constructor() {
		super();
		this.fetchProfile = this.fetchProfile.bind(this);
	}

	componentDidMount() {
		this.fetchProfile();
	}

	componentDidUpdate(prevProps) {
		const { token, initializeForm, formInitialValues } = this.props;

		if (token && prevProps.token !== token) {
			this.fetchProfile();
		}

		const country = get(this.props, "formInitialValues.contact.address.country");
		const prevCountry = get(prevProps, "formInitialValues.contact.address.country");
		if (country !== prevCountry) {
			initializeForm(formInitialValues);
		}
	}

	fetchProfile() {
		const { getProfile, onFetchProfilSuccess, onFetchProfilFail } = this.props;

		if (shouldGetProfileAtPayment()) {
			getProfile()
				.then(() => {
					if (typeof onFetchProfilSuccess === "function") {
						onFetchProfilSuccess();
					}
				})
				.catch(() => {
					if (typeof onFetchProfilFail === "function") {
						onFetchProfilFail();
					}
				});
		}
	}

	render() {
		return <PaymentContact {...this.props} />;
	}
}

PaymentContactContainer.propTypes = {
	initializeForm: PropTypes.func,
	formInitialValues: PropTypes.object,
	errors: PropTypes.array,
	nameField: PropTypes.object,
	emailField: PropTypes.object,
	phoneField: PropTypes.object,
	addressField: PropTypes.object,
	onCountryChange: PropTypes.func,
	handleInputBlur: PropTypes.func,
	contactRef: PropTypes.object,
	onFetchProfilSuccess: PropTypes.func,
	onFetchProfilFail: PropTypes.func,
	getProfile: PropTypes.func,
	token: PropTypes.string,
};

const mapStateToProps = state => {
	return {
		strategy: state.partner.strategy,
		isAuthenticated: isAuthenticated(state),
		token: state.auth.token,
		shop: getCurrentShop(state),
		isLoading: state.profile.status === PROFILE_CODE_STATUS.LOADING,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ getProfile }, dispatch);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(PaymentContactContainer));
